import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { AddbalanceComponent } from './addbalance/addbalance.component';
import { UploadphotoComponent } from './uploadphoto/uploadphoto.component';
import { countries } from 'country-list-json';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { CountrycheckComponent } from '../taskcost/countrycheck/countrycheck.component';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { QuotationPopupComponent } from '../userregister/quotation-popup/quotation-popup.component';
import { EMAIL_REGEX } from 'src/app/services/constants';
import { TaskService } from 'src/app/services/task.service';
import { Subscription } from 'rxjs';
import { USER_CAN_DEPOSIT } from 'src/app/services/constants';
import { AllocationNotificationComponent } from '../fund-allocation/allocation-notification/allocation-notification.component';
import { PopupService } from 'src/app/services/popup.service';
import {  TemplateRef } from '@angular/core';
import { RegistersuccessComponent } from '../userregister/registersuccess/registersuccess.component';
import { FootersuccessComponent } from '../shared/footer/footersuccess/footersuccess.component';
import { ConfirmPopupComponent } from '../shared';
import { UtilsService } from 'src/app/services/utils.service';


interface Country {
  value: any;
  viewValue: string;
}

interface PricingSensorItem {
  label: string;
  category: 'MSI' | 'SAR' | 'HSI' | 'SWIR' | 'GHG' | 'TIR' | 'neutral';
}

interface PricingPlanCard {
  planId: number;
  title: string;
  subtitle: string;
  depositLabel: string;
  depositAmount: string;
  depositSupport: string;
  sensorHeading: string;
  sensorSubtext: string;
  sensorCount: string;
  sensorItems: PricingSensorItem[];
  featureHeading: string;
  features: string[];
  recommended?: boolean;
  enterprise?: boolean;
  enterpriseSensorSummary?: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent
  implements OnInit, AfterViewChecked
{
  isShown: boolean = false;
  isShownremember: boolean = false;
  currentUser: any;
  userDetails: any;
  userid: any;
  currencySign = environment.payCurrencySign;
  userPhoto: any;
  userAddress: any;
  editable = false;
  show = false;
  msg: any;
  newmsg: any;
  oldmsg: any;
  userForm: FormGroup | any;
  addressForm: FormGroup | any;
  targetForm: FormGroup | any;
  awsForm: FormGroup | any;
  azureForm: FormGroup | any;
  sftpForm: FormGroup | any;
  validationMessages: any;
  pswrdMatched: boolean;
  userPhotoFile: any | Blob;
  userImgUrl: string;
  inputAddress: boolean;
  payUrl: any;
  displayStyle = 'none';
  amount: number;
  click: boolean = false;
  balance: boolean = false;
  disableTextbox = true;
  newPassword: boolean = true;
  showPassword: boolean = true;
  address: any;
  address1: any = '';
  city: any = '';
  address2: any = '';
  zip_code: any = '';
  timezoneOptions: string[] = [];
  countries: any;
  photo: string;
  addressCheck = new FormControl();
  passwordCheck = new FormControl();
  awsCheck = new FormControl();
  currentUsers: any;
  isShownS3: boolean = false;
  totalTasking: any;
  isSending: boolean = false;
  locations = [
    { name: 'Amazon S3', value: 0, displayValue: 'Amazon S3' },
    { name: 'Azure Blob', value: 1, displayValue: 'Azure Blob' },
    { name: 'Vault (Australia)', value: 2, displayValue: 'Vault (Australia)' },
    { name: 'SFTP', value: 3, displayValue: 'Secure FTP' },
  ];
  demoView: boolean = false;
  allocationCheck = new FormControl();
  displayedColumns: string[] = [
    'sensorType',
    'sensorName',
    'location',
    'taskingTier',
    'totalTasks',
    'remainingTaks',
  ];
  expandedStates: { [key: number]: boolean } = {};
  expandedPricingPlanIds: number[] = [];
  selectedPricingPlanId: number | null = null;
  accessDetails:any
  pricingCardsDialogRef: MatDialogRef<any> | null = null;
  plans = [
  {
    title: "Starter",
    subtitle: "For First-Time Or Occasional Users",
    isPopular: false,
    planId:1,
    details:[
      {text:"No annual deposit",icon:false},
      {text:"Access up to five Imaging Sensors",icon:true},
      {text:"Single user, one tasking workflow",icon:false},
      {text:"Support via platform ‘contact us’",icon:false}
    ],
     accessDetails:[
      {heading:"Access up to five Imaging Sensors"},
      "1 sub-m Multispectral Imaging (MSI)",
      "1 above 1m MSI",
      "1 sub-10m Hyperspectral Imaging (HSI)",
      "2 sub-m Synthetic Aperture Radar (SAR) (X band)"
    ]
  },
  {
    title: "Standard",
    subtitle: "For Regular Users",
    price: 5000,
    priceView: "5,000.00",
    isPopular: true ,  // this one will show the "Most Popular" badge,
    planId:2,
    details:[
      {text:"Minimum US$ 5,000 annual deposit",icon:false},
      {text:"Access up to ten Imaging Sensors",icon:true},
      {text:"Multi-user, multi-tasking workflows",icon:false},
      {text:"Access to simple feeds",icon:false},
      {text:"Support via onboarding, platform ‘contact us’, and email",icon:false}
    ],
    accessDetails:[
      {heading:"Access up to ten Imaging Sensors"},
      "1 Panchromatic (PAN)",
      "4 MSI (below 1m and above 1m)",
      "3 SAR (X, C bands)",
      "1 HSI",
      "1 Thermal Infrared (TIR)"
    ]
  },
  {
    title: "Premium",
    subtitle: "For High-Volume Users",
    price: 50000,
    priceView: "50,000.00",
    isPopular: false,
    planId:3,
    details:[
      {text:"Minimum US$ 50,000 annual deposit",icon:false},
      {text:"Full access to all Sensors",icon:true},
      {text:"Pay Now, Debit Account, or Pay Later by invoice",icon:false},
      {text:"Tip-and-Cue and other advanced tasking, permission-based enterprise workflows, and user-level budgets",icon:false},
      {text:"Access to advanced feeds",icon:false},
      {text:"Support via onboarding, platform ‘contact us’, email and monthly check-in",icon:false}
    ],
     accessDetails:[
      {heading:"Full access to all Sensors"},
      "Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI",
      "MSI starts at 15cm",
      "L-band SAR",
      "InSAR (X, C, and L bands)",
      "Greenhouse Gases (GHG)",
      "Automatic Identification System (AIS) and RF-communication"
    ]
  },
   {
    title: "Enterprise",
    subtitle: "For related entities users",
    price: 100000,
    priceView: "100,000.00",
    isPopular: false,
    planId:4,
    details:[
      {text:"Minimum US$ 100,000 annual deposit",icon:false},
      {text:"Hierarchical and multi-account management",icon:false},
      {text:"Data and information report generation",icon:false},
      {text:"Activity tracking",icon:false},
      {text:"Slack + dedicated support channel",icon:false},
      {text:"Support via onboarding, platform ‘contact us’, email, Slack and monthly check-in",icon:false}
    ]
  }
];
    pricingCards: PricingPlanCard[] = [
      {
        planId: 1,
        title: 'Starter',
        subtitle: 'For First-Time Or Occasional Users',
        depositLabel: 'Annual Deposit',
        depositAmount: 'No Minimum',
        depositSupport: 'Pay Now via PayPal or Stripe, Debit Account',
        sensorHeading: 'Imaging sensors',
        sensorSubtext: 'Click to view breakdown',
        sensorCount: '5',
        featureHeading: 'Includes',
        sensorItems: [
          { label: '1 sub-m Multispectral Imaging (MSI)', category: 'MSI' },
          { label: '1 above 1m MSI', category: 'MSI' },
          { label: '1 sub-10m Hyperspectral Imaging (HSI)', category: 'HSI' },
          { label: '2 sub-m Synthetic Aperture Radar (SAR) (X band)', category: 'SAR' }
        ],
        features: [
          'Single user, one tasking workflow',
          'Support via platform ‘contact us’'
        ]
      },
      {
        planId: 2,
        title: 'Standard',
        subtitle: 'For Regular Users',
        depositLabel: 'Annual Deposit From',
        depositAmount: 'US$ 5,000',
        depositSupport: 'Pay Now, Debit Account',
        sensorHeading: 'Imaging sensors',
        sensorSubtext: 'Click to view breakdown',
        sensorCount: '10',
        featureHeading: 'More of everything from users to sensors',
        sensorItems: [
          { label: '1 Panchromatic (PAN)', category: 'MSI' },
          { label: '4 MSI (below 1m and above 1m)', category: 'MSI' },
          { label: '3 SAR (X, C bands)', category: 'SAR' },
          { label: '1 HSI', category: 'HSI' },
          { label: '1 Thermal Infrared (TIR)', category: 'TIR' }
        ],
        features: [
          'Multi-user, multi-tasking workflows',
          'Access to simple feeds',
          'Support via onboarding, platform ‘contact us’ and email'
        ]
      },
      {
        planId: 3,
        title: 'Premium',
        subtitle: 'For High-Volume Users',
        depositLabel: 'Annual Deposit From',
        depositAmount: 'US$ 50,000',
        depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
        sensorHeading: 'Sensors',
        sensorSubtext: 'Full constellation access',
        sensorCount: '20+',
        recommended: true,
        featureHeading: 'Everything in Standard plus',
        sensorItems: [
          { label: 'Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI', category: 'neutral' },
          { label: 'MSI starts at 15cm', category: 'MSI' },
          { label: 'Stereo and Tri-stereo in several optical resolutions', category: 'MSI' },
          { label: 'L-band SAR', category: 'SAR' },
          { label: 'InSAR (X, C, and L bands)', category: 'SAR' },
          { label: 'Greenhouse Gases (GHG)', category: 'GHG' },
          { label: 'Shortwave Infrared (SWIR)', category: 'SWIR' },
          { label: 'Automatic Identification System (AIS) and RF-communication', category: 'neutral' }
        ],
        features: [
          'Tip-and-Cue and other advanced tasking, permission-based enterprise workflows and user level budgets',
          'Access to advanced feeds',
          'Support via onboarding, platform ‘contact us’, email and monthly check-in'
        ]
      },
      {
        planId: 4,
        title: 'Enterprise',
        subtitle: 'For Related Entities & Organisations',
        depositLabel: 'Annual Deposit From',
        depositAmount: 'US$ 100,000',
        depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
        sensorHeading: 'Sensors',
        sensorSubtext: 'Full constellation access',
        sensorCount: '20+',
        enterprise: true,
        enterpriseSensorSummary: 'Full Premium sensor suite, tailored to operational requirements.',
        featureHeading: 'Everything in Premium plus',
        sensorItems: [
          { label: 'All Premium sensor access', category: 'neutral' },
          { label: 'Expanded MSI, SAR, HSI and advanced analytics coverage', category: 'MSI' },
          { label: 'Enterprise-scale access for related entities', category: 'neutral' }
        ],
        features: [
          'Hierarchical and multi-account management',
          'Data and information report generation',
          'Activity tracking',
          'Slack + dedicated support channel',
          'Support via onboarding, platform ‘contact us’, email, Slack and monthly check-in'
        ]
      }
    ];
  @ViewChild('dispname', { static: true }) dispname: ElementRef;
  @ViewChild('email', { static: true }) email: ElementRef;
  @ViewChild('fullName', { static: true }) fullName: ElementRef;
  @ViewChild('orgName', { static: true }) orgName: ElementRef;
  @ViewChild('website', { static: true }) website: ElementRef;
  @ViewChild('department', { static: true }) department: ElementRef;
  @ViewChild('role', { static: true }) role: ElementRef;
  taskId: string | null;
  awsType: boolean = false;
  azureType: boolean = false;
  targetSaved: number;
  isawsForm: boolean = true;
  isazureForm: boolean = true;
  isDisplay: boolean = false;
  dataSource: MatTableDataSource<any>;
  darkTheme: boolean;
  issftpForm: boolean = true;
  sftpType: boolean = false;
  deletedImagePath: string;
  isInIframe: boolean;
  payment: boolean;
  panelOpenState = true;
  isFirst = true;
  disableName: boolean = true;
  disableEmail: boolean = true;
  disableTimezone: boolean = true;
  invalidEmail: boolean = false;
  noChange: boolean = true;
  emailId: any;
  displayName: any;
  exist: boolean = false;
  checkFtpStatus: boolean = false;
  isEmailTruncated: boolean = false;
  isFullNameTruncated: boolean = false;
  isDispNameTruncated: boolean = false;
  isOrgNameTruncated: boolean = false;
  isWebsiteTruncated: boolean = false;
  isDepartmentTruncated: boolean = false;
  isRoleTruncated: boolean = false;
  isFocused: boolean = false;
  dialogRef: MatDialogRef<CountrycheckComponent> | null = null;
  loaderMessage =
    'The target location is being verified with the saved credentials. Please wait for one to two minutes, depending on the network connection, and do not close the screen.';
  private updateSub: Subscription;

  constructor(
    private matdialog: MatDialog,
    private authService: AuthService,
    private userSevice: UserService,
    private fb: FormBuilder,
    private userService: UserService,
    private router: Router,
    private apiService: ApiService,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private taskService: TaskService,
    private popupService: PopupService,
    private dialog: MatDialog,
    public utilsService: UtilsService
  ) {
    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    this.isInIframe = this.themeService.isInIframe();
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.deletedImagePath = this.darkTheme
        ? '../../../assets/images/deleted-dark.png'
        : '../../../assets/images/deleted.png';
    });
  }
  ngAfterViewInit(): void {
    // throw new Error('Method not implemented.');
    // TODO: add your AfterViewInit code here
  }

  async ngOnInit() {
    this.apiService.getAllocation().subscribe((res: any) => {
      if (res?.allocations[0]?.sensor.length > 0) {
        let tableData = res.allocations[0].sensor;
        const addedData = tableData.filter((data) => data.isAllocated === true);
        const totalTasks = addedData.reduce(
          (total, data) => total + data.remaining_task,
          0
        );
        this.totalTasking = totalTasks;
      }
    });
    this.countries = countries;
    if (localStorage.getItem('taskData')) {
      this.payment = true;
    } else this.payment = false;

    this.userForm = this.fb.group({
      oldPassword: [
        '',
        Validators.compose([
          Validators.required,
          // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
        ]),
      ],
      newPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
        ]),
      ],
      confirmPassword: [''],
    });

    this.addressForm = this.fb.group({
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      country: [''],
      zip_code: [''],
      timezone: ['', [Validators.required]],
    });

    this.setupTimezoneSelection();

    this.targetForm = this.fb.group({
      location: ['', [Validators.required]],
    });

    this.awsForm = this.fb.group({
      accessKey: ['', [Validators.required]],
      secretKey: ['', [Validators.required]],
      region: ['', [Validators.required]],
      bucketName: ['', [Validators.required]],
    });

    this.azureForm = this.fb.group({
      azureAccountName: ['', [Validators.required]],
      azureContainer: ['', [Validators.required]],
      azureSasToken: ['', [Validators.required]],
    });

    this.sftpForm = this.fb.group({
      sftpHostname: ['', [Validators.required]],
      sftpUsername: ['', [Validators.required]],
      sftpPassword: ['', [Validators.required]],
      port: [22, [Validators.required]],
      sftpRegionValue: ['', [Validators.required]],
    });

    this.getUser();

    this.awsForm.valueChanges.subscribe(() => {
      this.isawsForm = false;
    });
    this.azureForm.valueChanges.subscribe(() => {
      this.isazureForm = false;
    });
    this.sftpForm.valueChanges.subscribe(() => {
      this.issftpForm = false;
    });
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value.trim();
    if (value !== '' && parseInt(value) < 0) {
      inputElement.value = '';
      this.sftpForm.patchValue({
        port: '',
      });
    }
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  get sign() {
    return this.addressForm.controls;
  }
  get f() {
    return this.userForm.controls;
  }

  get aws() {
    return this.awsForm.controls;
  }

  get azure() {
    return this.azureForm.controls;
  }

  get sftp() {
    return this.sftpForm.controls;
  }

  get target() {
    return this.targetForm.controls;
  }

  quotation = false;
  quotationAmount = 0;
  requestQuotation() {
    this.quotationAmount = 0;

    const dialogRef = this.matdialog.open(QuotationPopupComponent, {
      backdropClass: 'blurred',
      disableClose: true,
      width: '60%',
      data: { message: 'profile' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.type === 1) {
        this.quotation = true;
        this.quotationAmount = result.quotationAmount;
        this.authService
          .addQuotationToTopup(this.quotationAmount, this.currentUsers?.id)
          .subscribe();
      } else this.quotation = false;
    });
  }

  getUser() {
    this.authService.user.subscribe((user) => (this.currentUsers = user));
    this.userService
      .personalInfo(this.currentUsers?.id)
      .subscribe(async (res: any) => {
        this.currentUsers = res;
        if (!this.currentUsers?.verified) {
          this.authService.logoutAndReset();
        } else {
          this.userDetails = this.currentUsers;
          this.address1 = this.userDetails?.address1;
          this.city = this.userDetails?.city;
          if (this.userDetails?.address2)
            this.address2 = ', ' + this.userDetails?.address2;
          if (this.userDetails?.zip_code)
            this.zip_code = ', ' + this.userDetails?.zip_code;
          this.address =
            this.address1 + this.address2 + ', ' + this.city + this.zip_code;
          if (
            this.userDetails.photo !== undefined &&
            !this.userDetails.photo.includes('eeusersapi')
          )
            this.photo =
              environment.usersServer + '/data/' + this.userDetails.photo;
          this.selectRecord(this.userDetails);
        }
      });
  }

  selectRecord(userDetails: any) {
    this.addressForm.get('address1').setValue(userDetails?.address1);
    this.addressForm.get('address2').setValue(userDetails?.address2);
    this.addressForm.get('city').setValue(userDetails?.city);
    this.addressForm.get('country').setValue(userDetails?.country);
    this.addressForm.get('zip_code').setValue(userDetails?.zip_code);
    this.addressForm
      .get('timezone')
      .setValue(userDetails?.timezone || this.utilsService.getUserTimezone(userDetails));
    this.awsForm.get('secretKey').setValue(userDetails?.secretKey);
    this.awsForm.get('accessKey').setValue(userDetails?.accessKey);
    this.awsForm.get('region').setValue(userDetails?.region);
    this.awsForm.get('bucketName').setValue(userDetails?.bucketName);
    this.azureForm
      .get('azureAccountName')
      .setValue(userDetails?.azureAccountName);
    this.azureForm.get('azureContainer').setValue(userDetails?.azureContainer);
    this.azureForm.get('azureSasToken').setValue(userDetails?.azureSasToken);
    this.sftpForm.get('sftpHostname').setValue(userDetails?.sftpHostname);
    this.sftpForm.get('sftpUsername').setValue(userDetails?.sftpUsername);
    this.sftpForm.get('sftpPassword').setValue(userDetails?.sftpPassword);
    this.sftpForm.get('port').setValue(userDetails?.port);
    this.sftpForm
      .get('sftpRegionValue')
      .setValue(userDetails?.sftpRegion?.[0] || null);

    if (userDetails?.storageLocation) {
      this.targetForm.get('location').setValue(userDetails?.storageLocation);
      const targetFilter = this.locations.filter(
        (el) => el.name === userDetails.storageLocation
      );
      this.targetSaved = targetFilter[0]?.value;
      this.storageType(targetFilter[0]?.value);
    }
    this.isawsForm = true;
    this.isazureForm = true;
    this.issftpForm = true;
  }

  toggleDisable() {
    this.disableTextbox = !this.disableTextbox;
    this.dispname.nativeElement.focus();
  }
  toggleShow() {
    this.isShown = !this.isShown;
  }
  toggleShowaddress() {
    this.isShownremember = !this.isShownremember;
    this.selectRecord(this.userDetails);
  }

  toggleS3() {
    this.isShownS3 = !this.isShownS3;
    this.selectRecord(this.userDetails);
  }

  OpenPopup() {
    if (this.userDetails?.userType === 'Super user' || this.canDeposit()) {
      const dialogRef = this.matdialog.open(AddbalanceComponent, {
        // width: !this.payment || this.isInIframe ? '37%' : '30%',
        backdropClass: 'blurred',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.msg === 'OK') {
          this.balance = true;
        }
      });
    } else {
      const message = `You are not authorised to make a deposit. Please get in touch with your lead user to enable permission.`;
      this.popupService.openPopup(
        AllocationNotificationComponent,
        message,
        '',
        '50%'
      );
    }
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  public toggleconfirmPasswordVisibility(): void {
    this.newPassword = !this.newPassword;
  }

  Openupload() {
    const dialogRef = this.matdialog.open(UploadphotoComponent, {
      width: '40%',
      backdropClass: 'blurred',
      disableClose: true,
    });
    backdropClass: 'backdropBackground'; // This is the "wanted" line
    dialogRef.afterClosed().subscribe((result) => {
      if (result.msg === 'OK') {
        this.click = true;
        window.location.reload();
      }
    });
  }
  keyPress(event: any) {
    this.newmsg = '';
  }
  keyPressIn(event: any) {
    this.oldmsg = '';
  }
  submit() {
    const oldPassword = this.userForm.value.oldPassword;
    const password = this.userForm.value.newPassword;
    if (oldPassword === password) {
      this.newmsg = 'Old Password and new password must not be same.';
      this.oldmsg = '';
      return;
    } else {
      const pswrdObj = { oldPassword, password };
      this.userSevice.changePswrd(this.currentUsers.id, pswrdObj).subscribe(
        async (res) => {
          this.msg = res;
          this.newmsg = '';
          this.passwordCheck.setValue(false);
          const msg = 'Password Updated Successfully';
          this.openWaraning('success', msg);
          this.isShown = !this.isShown;
        },
        (err) => {
          this.oldmsg = 'Old password is wrong';
          this.newmsg = '';
        }
      );
    }
  }
  chkOldNew() {
    if (this.userForm.value.oldPassword === this.userForm.value.password) {
      this.msg = 'Old Password and new password should not be same.';
      return;
    }
  }

  changeAddress() {
    this.saveAddressDetails(
      () => {
        const messsage = 'Address Updated Successfully';
        this.addressCheck.setValue(false);
        this.openWaraning('success', messsage);
        this.isShownremember = !this.isShownremember;
      }
    );
  }

  getCurrentTimezoneLabel(): string {
    const timezone = this.utilsService.getUserTimezone(this.userDetails);
    return timezone ? this.utilsService.formatTimezoneLabel(timezone) : '';
  }

  private setupTimezoneSelection(): void {
    const countryControl = this.addressForm?.get('country');
    const timezoneControl = this.addressForm?.get('timezone');

    if (!countryControl || !timezoneControl) {
      return;
    }

    countryControl.valueChanges.subscribe((countryName: string) => {
      this.timezoneOptions = this.utilsService.getTimezonesForCountry(countryName || '');

      if (!this.timezoneOptions.length) {
        timezoneControl.setValue('', { emitEvent: false });
        return;
      }

      const currentTimezone = timezoneControl.value;
      if (this.timezoneOptions.includes(currentTimezone)) {
        return;
      }

      const guessedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const nextTimezone = this.timezoneOptions.includes(guessedTimezone)
        ? guessedTimezone
        : this.timezoneOptions[0];

      timezoneControl.setValue(nextTimezone, { emitEvent: false });
    });

    timezoneControl.valueChanges.subscribe(() => {
      if (!this.disableTimezone) {
        this.updateNoChangeState();
      }
    });
  }

  private getAddressPayload() {
    const address1 = this.addressForm.value.address1?.trim();
    const address2 = this.addressForm.value.address2?.trim();
    const city = this.addressForm.value.city?.trim();
    const country = this.addressForm.value.country?.trim();
    const zip_code = this.addressForm.value.zip_code;
    const timezone = this.addressForm.value.timezone;

    return { address1, address2, city, country, zip_code, timezone };
  }

  private refreshUserDetails(): void {
    if (this.currentUsers?.id) {
      this.localStorageService.triggerRefreshUserDetails(this.currentUsers?.id);
      this.userService.personalInfo(this.currentUsers?.id).subscribe((res: any) => {
        this.userDetails = res;
        this.address1 = this.userDetails?.address1;
        this.city = this.userDetails?.city;
        this.address2 = this.userDetails?.address2
          ? ', ' + this.userDetails?.address2
          : '';
        this.zip_code = this.userDetails?.zip_code
          ? ', ' + this.userDetails?.zip_code
          : '';
        this.address =
          this.address1 + this.address2 + ', ' + this.city + this.zip_code;
        this.selectRecord(this.userDetails);
        this.dispname.nativeElement.value = this.userDetails.displayname;
        this.email.nativeElement.value = this.userDetails.email;
      });
    }
  }

  private saveAddressDetails(onSuccess: () => void, onError?: () => void): void {
    const addressObj = this.getAddressPayload();
    this.userSevice.changeAddress(this.currentUsers.id, addressObj).subscribe(
      async (res) => {
        this.msg = res;
        if (this.currentUsers?.email && addressObj.timezone) {
          this.authService.saveUserTimezonePreference(
            this.currentUsers.email,
            addressObj.timezone
          );
        }
        onSuccess();
        this.refreshUserDetails();
      },
      (err) => {
        this.msg = err.error;
        if (onError) {
          onError();
        }
      }
    );
  }

  private getSavedTimezone(): string {
    return this.userDetails?.timezone || this.utilsService.getUserTimezone(this.userDetails);
  }

  private hasTimezoneChanged(): boolean {
    return this.addressForm.get('timezone')?.value !== this.getSavedTimezone();
  }

  private updateNoChangeState(): void {
    this.noChange = !this.emailId && !this.displayName && !this.hasTimezoneChanged();
  }

  updateDetails(field: string, fieldVal: any) {
    if (fieldVal === this.userDetails.displayname || !fieldVal) {
      this.displayName = null;
      this.updateNoChangeState();
      return;
    } else {
      this.displayName = fieldVal;
      this.updateNoChangeState();
    }
  }

  saveStorage(formType: any) {
    const trimmedValue = {};
    const azureTrimmedvalues = {};
    this.checkFtpStatus = false;
    const sftpTrimmedvalues = {};
    let sftpFormData: any;

    if (!this.checkFtpStatus) {
      this.openWaraning('warning', this.loaderMessage);
    }

    if (formType === 'awsForm') {
      this.azureForm.reset();
      this.sftpForm.reset();
    } else if (formType === 'azureForm') {
      this.awsForm.reset();
      this.sftpForm.reset();
    } else if (formType === 'sftpForm') {
      this.azureForm.reset();
      this.awsForm.reset();

      if (!this.sftpForm.contains('sftpRegion')) {
        this.sftpForm.addControl(
          'sftpRegion',
          new FormControl(this.sftpForm.get('sftpRegionValue').value?._id)
        );
      } else {
        this.sftpForm
          .get('sftpRegion')
          .setValue(this.sftpForm.get('sftpRegionValue').value?._id);
      }
      sftpFormData = { ...this.sftpForm.value };
      delete sftpFormData.sftpRegionValue;
    }

    Object.keys(this.awsForm.value).forEach((key) => {
      const value = this.awsForm.value[key];
      trimmedValue[key] = typeof value === 'string' ? value.trim() : value;
    });
    Object.keys(this.azureForm.value).forEach((key) => {
      const value = this.azureForm.value[key];
      azureTrimmedvalues[key] =
        typeof value === 'string' ? value.trim() : value;
    });

    this.awsForm.setValue(trimmedValue);
    this.azureForm.setValue(azureTrimmedvalues);

    const storageObj = {
      ...this.targetForm.value,
      ...this.awsForm.value,
      ...this.azureForm.value,
      ...sftpFormData,
    };

    this.isawsForm = true;
    this.isazureForm = true;
    this.issftpForm = true;

    this.updateSub = this.userSevice
      .updateStorage(this.currentUsers.id, storageObj)
      .subscribe(async (res) => {
        if (res === 'success') {
          this.checkFtpStatus = true;
          const msg = 'Target Data Delivery Updated Successfully';
          this.openWaraning('success', msg);
          this.awsCheck.setValue(false);
          this.isShownS3 = !this.isShownS3;
          this.userService
            .personalInfo(this.currentUsers?.id)
            .subscribe((res: any) => {
              this.userDetails = res;
            });
          if (localStorage.getItem('storage')) {
            this.taskId = localStorage.getItem('storageId');
            this.router.navigate(['/payment'], {
              queryParams: { taskId: this.taskId, type: 'cart' },
            });
          }
        } else {
          this.openWaraning('target', res);
        }
      });
  }

  openWaraning(type, msg) {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.dialogRef = this.matdialog.open(CountrycheckComponent, {
      width: '40%',
      backdropClass: 'blurred',
      disableClose: true,
      data: { message: type, info: msg },
    });
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'no' && this.updateSub) {
        this.updateSub.unsubscribe();
      }
    });
  }

  storageType(type: any) {
    this.awsType = false;
    this.azureType = false;
    this.sftpType = false;
    this.isawsForm = true;
    this.isazureForm = true;
    this.issftpForm = true;

    if (this.targetSaved === 0) {
      this.azureForm.reset();
      this.sftpForm.reset();
    } else if (this.targetSaved === 1) {
      this.awsForm.reset();
      this.sftpForm.reset();
    } else if (this.targetSaved === 3) {
      this.awsForm.reset();
      this.azureForm.reset();
    }

    if (type === 0) this.awsType = true;
    else if (type === 1) this.azureType = true;
    else if (type === 3) this.sftpType = true;
  }

  toggleAllocation() {
    this.isDisplay = !this.isDisplay;
    this.getData();
  }

  getData() {
    this.apiService.getAllocation().subscribe((res: any) => {
      if (res?.allocations[0]?.sensor.length > 0) {
        let tableData = res.allocations[0].sensor;
        const addedData = tableData.filter((data) => data.isAllocated === true);
        this.dataSource = new MatTableDataSource<any>(addedData);
      }
    });
  }

  toggleDisplayName() {
    this.disableName = !this.disableName;
    if (this.disableName) {
      this.dispname.nativeElement.blur();
    } else {
      this.dispname.nativeElement.focus();
    }
    this.dispname.nativeElement.value = this.userDetails.displayname;
    this.updateNoChangeState();
  }

  toggleEmailEdit() {
    this.disableEmail = !this.disableEmail;
    if (this.disableEmail) {
      this.email.nativeElement.blur();
    } else {
      this.email.nativeElement.focus();
    }
    this.exist = false;
    this.invalidEmail = false;
    this.email.nativeElement.value = this.userDetails.email;
    this.updateNoChangeState();
  }

  toggleTimezoneEdit() {
    if (this.demoView) {
      return;
    }

    this.disableTimezone = !this.disableTimezone;
    if (this.disableTimezone) {
      this.addressForm.get('timezone')?.setValue(this.getSavedTimezone(), {
        emitEvent: false,
      });
    }
    this.updateNoChangeState();
  }

  updateEmail(fieldVal: any) {
    this.exist = false;
    if (!EMAIL_REGEX.test(fieldVal)) {
      this.invalidEmail = true;
      return;
    } else {
      this.invalidEmail = false;
    }

    if (fieldVal === this.userDetails.email) {
      this.emailId = null;
      this.updateNoChangeState();
      return;
    } else {
      this.emailId = fieldVal;
      this.updateNoChangeState();
    }
  }

  editPersonalSettings() {
    const email = this.emailId?.toLowerCase() ?? '';
    const hasProfileFieldChanges = !!(this.emailId || this.displayName);
    const hasTimezoneChanges = this.hasTimezoneChanged();

    if (!hasProfileFieldChanges && !hasTimezoneChanges) {
      return;
    }

    this.noChange = true;

    const completePersonalUpdate = (shouldRefresh = true) => {
      this.disableEmail = true;
      this.disableName = true;
      this.disableTimezone = true;
      this.emailId = null;
      this.displayName = null;
      this.exist = false;
      this.invalidEmail = false;
      this.noChange = true;
      const msg = 'Changes Updated Successfully';
      this.openWaraning('success', msg);
      if (shouldRefresh) {
        this.refreshUserDetails();
      }
    };

    const saveTimezoneChanges = () => {
      if (!hasTimezoneChanges) {
        completePersonalUpdate();
        return;
      }

      this.saveAddressDetails(
        () => {
          completePersonalUpdate(false);
        },
        () => {
          this.noChange = false;
        }
      );
    };

    if (!hasProfileFieldChanges) {
      saveTimezoneChanges();
      return;
    }

    this.userSevice
      .updateField(this.currentUsers.id, email, this.displayName)
      .subscribe((res) => {
        if (res.toString().includes('Update')) {
          saveTimezoneChanges();
        } else {
          this.exist = true;
          this.noChange = false;
        }
      });
  }

  cancelChanges() {
    this.dispname.nativeElement.value = this.userDetails.displayname;
    this.email.nativeElement.value = this.userDetails.email;
    this.addressForm.get('timezone')?.setValue(this.getSavedTimezone(), {
      emitEvent: false,
    });
    this.disableName = true;
    this.disableEmail = true;
    this.disableTimezone = true;
    this.noChange = true;
    this.emailId = null;
    this.displayName = null;
    this.exist = false;
    this.invalidEmail = false;
  }

  checkSupportedTarget(row) {
    if (row.aoi && row.poi) return 'POI & AOI';
    else if (row.aoi) return 'AOI';
    else if (row.poi) return 'POI';
    else return '';
  }

  onCheckboxChange(event) {
    let dataObj = {
      permissionBased: event.checked,
      userId: this.currentUsers.id,
    };
    this.taskService.setPermission(dataObj).subscribe((res: any) => {});
  }

  canDeposit() {
    return (
      this.userDetails?.permission_based &&
      this.userDetails?.permissions.includes(USER_CAN_DEPOSIT)
    );
  }

  isBudgetMaxed() {
    return (
      this.userDetails?.user_plan == 4 &&
      this.userDetails?.totalBudget > 0 &&
      this.userDetails?.totalBudget === this.userDetails?.acBalance
    );
  }

  budgetAllocation(event) {
    let dataObj = {
      sub_budget_allocation: event.checked,
      userId: this.currentUsers.id,
    };
    this.taskService.setBudgetAllocation(dataObj).subscribe((res: any) => {});
  }
  ngAfterViewChecked() {
    if (this.disableEmail) {
      this.isEmailTruncated = this.checkTruncation(this.email);
    }
    this.isFullNameTruncated = this.checkTruncation(this.fullName);
    this.isOrgNameTruncated = this.checkTruncation(this.orgName);
    this.isWebsiteTruncated = this.checkTruncation(this.website);
    this.isDepartmentTruncated = this.checkTruncation(this.department);
    this.isRoleTruncated = this.checkTruncation(this.role);
    if (this.disableName) {
      this.isDispNameTruncated = this.checkTruncation(this.dispname);
    }
  }

  checkTruncation(elementRef: ElementRef): boolean {
    const el = elementRef.nativeElement;
    return el.scrollWidth > el.clientWidth;
  }
 hasFeature(key: string): boolean {
  return this.userDetails?.planDetails?.features?.some(feature => feature.key.toLowerCase() === key.toLowerCase());
}

  selectPlan(plan) {
  const newplandetails = 
    {
    "userId": this.userDetails.id,
    "newUserPlan": plan.planId
   };
  localStorage.setItem('newPlan',  plan.planId);
  localStorage.setItem('newPlanName',  plan.title);
    if (Number(this.userDetails?.user_plan ?? 0) > Number(plan?.planId ?? 0)) {
   const currentPlanTitle = this.plans.find(p => p.planId === Number(this.userDetails?.user_plan))?.title;
   const currentPlanDetails = this.plans.find(p => p.planId === Number(this.userDetails?.user_plan))?.details;


      const dialogRef = this.matdialog.open(ConfirmPopupComponent, {
        width: '50%',
        disableClose: true,
        backdropClass: 'blurred',
        data: { message: 'upgrade',
          selectedPlan :plan.title.toLowerCase(),
          currentPlan :  currentPlanTitle ? currentPlanTitle.toLowerCase() : "",
          currentPlanDetails : currentPlanDetails
         }
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        if (result === 'yes' && plan?.planId != 1) {
          this.openAddBalanceDialog(plan)
        }
        else if (result === 'yes' && plan?.planId == 1) {
          this.apiService.planUpdate(newplandetails).subscribe((res: any) => {
            if (res.success == true) {

              const dialogRef = this.dialog.open(RegistersuccessComponent, {
                data: { user: this.currentUser, type: 'planUpgrade', plan:plan.title.toLowerCase(), },
                backdropClass: 'blurred',
                disableClose: true,
                width: '35%'
              });

              dialogRef.afterClosed().subscribe(() => {
                this.getUser();
              });

            }
          });
        }

      });
    }
    else {
      this.openAddBalanceDialog(plan)
    }
  }
  openAddBalanceDialog(plan) {
    const dialogRef = this.matdialog.open(AddbalanceComponent, {
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        message: "planUpgarde",
        plan: plan,
        userDetails: this.userDetails
      }
    });
  }
  openPricingCardsDialog(template: TemplateRef<any>, planId?: number) {
    this.selectedPricingPlanId = planId ?? null;
    this.expandedPricingPlanIds = [];
    this.pricingCardsDialogRef = this.dialog.open(template, {
      width: '640px',
      maxWidth: 'calc(100vw - 32px)',
      backdropClass: 'blurred',
      panelClass: this.darkTheme
        ? ['plan-cards-dialog-panel', 'plan-cards-dialog-panel--dark']
        : 'plan-cards-dialog-panel'
    });

    this.pricingCardsDialogRef.afterClosed().subscribe(() => {
      this.pricingCardsDialogRef = null;
      this.expandedPricingPlanIds = [];
      this.selectedPricingPlanId = null;
    });
  }

  getSelectedPricingCard(): PricingPlanCard | undefined {
    return this.pricingCards.find((card) => card.planId === this.selectedPricingPlanId);
  }

  selectPlanFromPricingDialog(planId: number) {
    const selectedPlan = this.plans.find(plan => plan.planId === planId);

    this.pricingCardsDialogRef?.close();
    if (selectedPlan) {
      this.selectPlan(selectedPlan);
    }
  }

  togglePricingAccordion(planId: number) {
    this.expandedPricingPlanIds = this.isPricingAccordionOpen(planId)
      ? this.expandedPricingPlanIds.filter((id) => id !== planId)
      : [...this.expandedPricingPlanIds, planId];
  }

  isPricingAccordionOpen(planId: number): boolean {
    return this.expandedPricingPlanIds.includes(planId);
  }

  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

  isExpanded(index: number): boolean {
    return this.expandedStates[index] || false;
  }

sendEmail() {
  this.isSending = true
   const user = {
    userId: this.userDetails.id
  };
   const data = 'planUpgrade';
  this.apiService.planUpgradeSalesNotification(user).subscribe((res: any) => {
      this.isSending = false;
     if (res.success == true) {
        this.dialog.open(FootersuccessComponent, { width: '40%', backdropClass: 'blurr', data });
      }
  });
}
openTooltip(template: TemplateRef<any>,plan) {
  this.accessDetails=plan.accessDetails;
   this.dialogRef = this.dialog.open(template, {
    panelClass: 'black-dialog-bg',
    data: {
      accessDetails: plan.accessDetails,
      product: 'planUpgrade'
    }
  });
}
onPanelClosed() {
  this.panelOpenState = false;
  this.expandedStates = [];
  this.expandedPricingPlanIds = [];
}
}
